module.exports = __webpack_public_path__ + "static/Claudia-ca42067e1dad32c8592c06fec036e00b.png";